import { useCallback } from "react";
import { defaultRangeExtractor } from "@tanstack/react-virtual";
import type { Range } from "@tanstack/react-virtual";

/**
 * Keeps the group header at the top of the viewport mounted once its own row
 * has scrolled out of range, so CSS can keep it pinned there.
 */
function useStickyGroupHeaders(groupRowIndexes: number[]) {
  const sticky = groupRowIndexes.length > 0;

  const rangeExtractor = useCallback(
    (range: Range) => {
      if (!sticky) {
        return defaultRangeExtractor(range);
      }

      let activeIndex = -1;
      groupRowIndexes.forEach((index) => {
        if (range.startIndex >= index) {
          activeIndex = index;
        }
      });

      const indexes = defaultRangeExtractor(range);
      if (activeIndex >= 0 && !indexes.includes(activeIndex)) {
        indexes.push(activeIndex);
        indexes.sort((a, b) => a - b);
      }

      return indexes;
    },
    [sticky, groupRowIndexes]
  );

  return { sticky, rangeExtractor };
}

export default useStickyGroupHeaders;
